// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { MasterAccountsCollectionModel } from "@ces/App/Services/MasterAccountsService";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export type MasterAccountsState = {
    data: MasterAccountsCollectionModel | null;
};

const initialMasterAccountState: MasterAccountsState = {
    data: null,
};

const xMasterAccounts = createTypedReducerWithImmer(initialMasterAccountState, {
    "xMasterAccounts/CompleteLoadShopAccounts": (
        draft: Draft<MasterAccountsState>,
        action: { accounts: MasterAccountsCollectionModel },
    ) => {
        draft.data = action.accounts!;
    },
});

(reducers as any).xMasterAccounts = xMasterAccounts;

export type xMasterAccountsState = {
    xMasterAccounts: MasterAccountsState;
} & ApplicationState;

type xMasterAccountsReducers = {
    MasterAccounts: typeof xMasterAccounts;
};

export type xMasterAccountsActions = Parameters<xMasterAccountsReducers[keyof xMasterAccountsReducers]>[1] | AnyAction;
